module.exports = __webpack_public_path__ + "media/src/images/favicons/favicon-32x32-331524640bd28059e4dd50a6c2f4ee08.png";